import React, { FC } from "react";
import { IconType } from "enums/Icon";
import { useTranslation } from "react-i18next";
import {
  ItemsViewMode,
  TILE_COLUMN_OPTIONS,
  TileColumns,
} from "../../../../hooks/useItemsViewPreferences";
import {
  ColumnsContainer,
  ColumnsSegment,
  ColumnsThumb,
  ControlsRow,
  ModeContainer,
  ModeIcon,
  ModeSegment,
  ModeThumb,
} from "./ViewModeControl.styles";

interface ViewModeControlProps {
  mode: ItemsViewMode;
  columns: TileColumns;
  onModeChange: (mode: ItemsViewMode) => void;
  onColumnsChange: (columns: TileColumns) => void;
}

const ViewModeControl: FC<ViewModeControlProps> = ({
  mode,
  columns,
  onModeChange,
  onColumnsChange,
}) => {
  const { t } = useTranslation("common");
  const isTiles = mode === "tiles";

  return (
    <ControlsRow>
      <ModeContainer role="group" aria-label={t("parcels.itemsView.viewMode")}>
        <ModeThumb $index={isTiles ? 1 : 0} />
        <ModeSegment
          type="button"
          $selected={!isTiles}
          aria-pressed={!isTiles}
          aria-label={t("parcels.itemsView.rowsView")}
          title={t("parcels.itemsView.rowsView")}
          onClick={() => onModeChange("rows")}
        >
          <ModeIcon type={IconType.ViewRows} />
        </ModeSegment>
        <ModeSegment
          type="button"
          $selected={isTiles}
          aria-pressed={isTiles}
          aria-label={t("parcels.itemsView.tilesView")}
          title={t("parcels.itemsView.tilesView")}
          onClick={() => onModeChange("tiles")}
        >
          <ModeIcon type={IconType.ViewTiles} />
        </ModeSegment>
      </ModeContainer>
      {isTiles && (
        <ColumnsContainer
          role="group"
          aria-label={t("parcels.itemsView.tileColumns")}
        >
          <ColumnsThumb $index={TILE_COLUMN_OPTIONS.indexOf(columns)} />
          {TILE_COLUMN_OPTIONS.map((option) => (
            <ColumnsSegment
              key={option}
              type="button"
              $selected={columns === option}
              aria-pressed={columns === option}
              onClick={() => onColumnsChange(option)}
            >
              {option}
            </ColumnsSegment>
          ))}
        </ColumnsContainer>
      )}
    </ControlsRow>
  );
};

export default React.memo(ViewModeControl);
